import React from "react"
import { graphql } from 'gatsby'

import { Container, Row } from "react-bootstrap"

import Layout from "../components/layout"
import SEO from "../components/seo"

export default ({ data }) => {
    const post = data.nodeActividades
    console.log(post);
    return (
  <Layout>
      <br />
      <h1 id="texttitleLayout" className="mx-auto my-0 cssanimation sequence fadeInBottom">{post.title}</h1>
      <br />
    <SEO title={post.title} />
    <Container className="">
<small>{post.created}</small><hr/>
<Container>
  <Row>
    <div dangerouslySetInnerHTML={{ __html: post.body.value }}></div>
  </Row>
    <small>{post.relationships.field_tags.name}</small>
</Container>
    
    </Container>
  </Layout>
)
    }
    export const query = graphql`
    query($id: String!) {
        nodeActividades(id: { eq: $id }) {
          title
        created(formatString: "DD-MMM-YYYY")
        id
        relationships {
          field_campus {
            name
          }
          field_tags {
            name
          }
          field_image {
            uri {
              url
            }
          }
        }
        body {
          value
        }
        path {
          alias
        }
      }
    }
  `